import ReportCard from "../components/ReportCard";
import { useExportReleases } from "@hooks/exports/useExportReleases";
import { useExportSamples } from "@hooks/exports/useExportSamples";
import { useExportRegisters } from "@hooks/exports/useExportRegisters";
import { useExportDevices } from "@hooks/exports/useExportDevices";
import { useExportIndividualWithAdditionalData } from "@hooks/exports/useExportIndividualWithAdditionalData";
import { useExportLocationsWithVisits } from "@hooks/exports/useExportLocationsWithVisits";

function ReportsScreen() {
  const individualsWithAdditionalData = useExportIndividualWithAdditionalData();
  const releases = useExportReleases();
  const samples = useExportSamples();
  const registers = useExportRegisters();
  const devices = useExportDevices();
  const community = useExportLocationsWithVisits();

  const reports = [
    {
      title: "Indivíduos",
      description:
        "Este relatório inclui dados sobre todos os animais individuais monitorados ou liberados através da plataforma.",
      onDownload: individualsWithAdditionalData.handleExport,
      isLoading: individualsWithAdditionalData.isLoading,
    },
    {
      title: "Solturas",
      description:
        'O relatório "Solturas" contém informações detalhadas sobre as ações de soltura de animais, incluindo data, local, equipe responsável e espécie.',
      onDownload: releases.handleExport,
      isLoading: releases.isLoading,
    },
    {
      title: "Amostras",
      description:
        "Este relatório lista todas as amostras biológicas coletadas em campo, incluindo sangue, soro, carrapatos, pulgas e outros.",
      onDownload: samples.handleExport,
      isLoading: samples.isLoading,
    },
    {
      title: "Registros",
      description:
        "Este relatório compila registros de animais em campo, como aqueles feitos de forma sistematizada (câmeras, fezes, rastros, avistamentos)",
      onDownload: registers.handleExport,
      isLoading: registers.isLoading,
    },
    {
      title: "Comunidades do Entorno",
      description:
        "Este relatório detalha as comunidades cadastradas, abrangendo informações sobre visitas realizadas, equipes responsáveis e dados de interação.",
      onDownload: community.handleExport,
      isLoading: community.isLoading,
    },
    {
      title: "Equipamentos",
      description:
        "Este relatório lista todos os dispositivos de monitoramento utilizados, como armadilhas fotográficas, colares GPS ou sensores, com seus respectivos dados de uso.",
      onDownload: devices.handleExport,
      isLoading: devices.isLoading,
    },
  ];

  return (
    <div className="w-full p-4 sm:p-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
        {reports.map((report) => (
          <ReportCard
            key={report.title}
            title={report.title}
            description={report.description}
            onDownload={report.onDownload}
            isLoading={report.isLoading}
          />
        ))}
      </div>
    </div>
  );
}

export default ReportsScreen;
